import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaskingService {
  public currentColor: Color = {name: 'Road', color: '#32bbbc8f'}
  public maskUrl: Subject<string> = new Subject<string>();
  public imageUrl: Subject<string> = new Subject<string>();
  public mask: any;
  public currentOpacity: number;
  public currentMaskUrl: string;
  public artboard: any;

  // TODO: This is a hack, do this right (using a model?)!
  public imgDimensionConfig = {
    "imgs": {
      width: 700,
      height: 1000,
      canvasWidth: 700,
      canvasHeight: 1000
      // width: 1250,
      // height: 650,
      // canvasWidth: 1250,
      // canvasHeight: 650
    }
  };

  public series = "imgs";

  constructor() {
  }
  public setColor(index: number): void {
  }

  public setArtboard(artboard: any): void {
    this.artboard = artboard;
  }

  public togglePixelation(): void {
    if (getComputedStyle(this.mask.dom.children[0]).imageRendering === 'pixelated') {
      this.mask.dom.children[0].style.imageRendering = 'auto';
    } else {
      this.mask.dom.children[0].style.imageRendering = 'pixelated';
    }
  }

  public getPixelation(): boolean {
    if (getComputedStyle(this.mask.dom.children[0]).imageRendering === 'pixelated') {
      return true;
    }
      return false;
  }


  public setImageUrl(url: string): void {
    var series = url.match(/[\w-]+\/[\w-]+\.(png|jpg)$/)[0].split("/")[0];
    this.setDimensions(series);
    if (this.mask && this.mask.dom.children[0].children.length > 0) {

      this.imageUrl.next(url);
    } else {

      this.imageUrl.next(url);
    }
  }

  public setDimensions(series: string): void {
    this.series = series;
  }

  public getDimensions(): void {
    return this.imgDimensionConfig[this.series];
  }

  public getImageUrl(): Observable<string> {
    return this.imageUrl;
  }


  public setMaskUrl(url: string): void {
    this.currentMaskUrl = url;
    this.maskUrl.next(url);
    this.updateMask(this.mask);
  }

  public getMaskUrl(): Observable<string> {
    return this.maskUrl;
  }

  public updateMask(mask): void {
    this.mask = mask;
    let i = 0;
    if (mask.dom.children[0].children.length > 0) {
      mask.dom.children[0].children.forEach(element => {
        if (element.classList[1] === 'completePoly') {
          const color = element.getAttribute('color');
        }
        i++;
      });
    }
  }

  public loadedMask(): boolean {
    if (this.mask.dom.children[0].children.length > 0) {
      for (let element of this.mask.dom.children[0].children) {
        if (element.classList[0] === 'existingMask') {
          return true;
        }
      }
    }
    return false;
  }





}

export class Color {
  public name: string;
  public color: string;
}
